import cn from 'classnames';
import { Col, Row } from "../../../GridV2";
import Action from "./Action";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AlertActions = function AlertActions(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'm' : _ref$type,
    cancelAction = _ref.cancelAction,
    confirmAction = _ref.confirmAction,
    isDark = _ref.isDark,
    totalInnerCols = _ref.totalInnerCols,
    hasMoreElements = _ref.hasMoreElements;
  var className = hasMoreElements ? 'mb-32' : '';
  if (cancelAction && confirmAction) {
    return /*#__PURE__*/_jsxs(Row, {
      className: cn('flex flex-col-reverse sm:flex-row', className),
      totalCols: totalInnerCols,
      children: [/*#__PURE__*/_jsx(Col, {
        className: "flex items-center justify-center",
        xs: totalInnerCols.xs,
        sm: totalInnerCols.sm / 2,
        md: totalInnerCols.md / 2,
        lg: totalInnerCols.lg / 2,
        children: /*#__PURE__*/_jsx(Action, {
          type: type,
          action: cancelAction,
          actionType: "cancel",
          isDark: isDark
        })
      }), /*#__PURE__*/_jsx(Col, {
        className: "flex items-center justify-center",
        xs: totalInnerCols.xs,
        sm: totalInnerCols.sm / 2,
        md: totalInnerCols.md / 2,
        lg: totalInnerCols.lg / 2,
        children: /*#__PURE__*/_jsx(Action, {
          type: type,
          action: confirmAction,
          actionType: "confirm",
          isDark: isDark
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(Action, {
    type: type,
    action: cancelAction || confirmAction,
    actionType: cancelAction ? 'cancel' : 'confirm',
    isDark: isDark,
    className: className
  });
};
export default AlertActions;